import { RESET_CONTAINER_COUNT } from './actionTypes';

export default designId => ({
  type: RESET_CONTAINER_COUNT,
  payload: { designId },
});
